var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "d-flex flex-row" }, [
    _c("div", { staticClass: "row flex-grow-1" }, [
      _c("div", { staticClass: "col-md-4" }, [
        _c("small", [_vm._v(_vm._s(_vm.$t("inventoryLocationAisle")))]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.bin.locationAisle,
              expression: "bin.locationAisle"
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            placeholder: _vm.$t("inventoryLocationAisle").toString()
          },
          domProps: { value: _vm.bin.locationAisle },
          on: {
            input: function($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.bin, "locationAisle", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-4" }, [
        _c("small", [_vm._v(_vm._s(_vm.$t("inventoryLocationRow")))]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.bin.locationRow,
              expression: "bin.locationRow"
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            placeholder: _vm.$t("inventoryLocationRow").toString()
          },
          domProps: { value: _vm.bin.locationRow },
          on: {
            input: function($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.bin, "locationRow", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-4" }, [
        _c("small", [_vm._v(_vm._s(_vm.$t("inventoryLocationPin")))]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.bin.locationPin,
              expression: "bin.locationPin"
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            placeholder: _vm.$t("inventoryLocationPin").toString()
          },
          domProps: { value: _vm.bin.locationPin },
          on: {
            input: function($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.bin, "locationPin", $event.target.value)
            }
          }
        })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ml-2" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-danger",
          attrs: { disabled: _vm.saving },
          on: {
            click: function($event) {
              return _vm.unlink()
            }
          }
        },
        [
          _vm.saving
            ? _c("Spinner", { attrs: { small: true } })
            : _c("i", { staticClass: "fa fa-trash" })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", [_c("small", [_vm._v(" ")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }